// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__326A5","insightsList":"newBusinessInsightsMenu_insightsList__3BmLV","active":"newBusinessInsightsMenu_active__QS4yH"};